import React from 'react'
import SideBarLayout from "../../layout/side-bar-layout"
import TabsWrappedLabel from "../../components/tabs/tabs-component"
import {Grid, Paper} from "@mui/material"
import TabelaDownloadArquivo from "./components/tabela-download-arquivo"
import ImageCarousel from "../../../components/image-carousel"


const TITLE_METODOLOGIA_PAGE = "Metodologia"

const MetodologiaPage = () => {

    const sections = [
        {images: ['./slide/Curvas1.JPG', './slide/Curvas2.JPG', './slide/Curvas3.JPG', './slide/Curvas4.JPG', './slide/Curvas5.JPG', './slide/Curvas6.JPG']},
        {images: ['./slide/GR1.JPG', './slide/GR2.JPG', './slide/GR3.JPG', './slide/GR4.JPG', './slide/GR5.JPG']},
        {images: ['./slide/Precos1.JPG', './slide/Precos2.JPG', './slide/Precos3.JPG', './slide/Precos4.JPG', './slide/Precos5.JPG', './slide/Precos6.JPG', './slide/Precos7.JPG', './slide/Precos8.JPG']},
    ]

    const docs = [
        {
            "id": "1",
            "arquivo": "MN.01_Manual de Metolodogia de Apreçamento e Curvas.pdf",
            "path": "./docs/MN_01_Manual_de_Metolodogia_de_Aprecamento_e_Curvas.pdf",
            "type": "pdf"
        },
        {
            "id": "2",
            "arquivo": "PL_06_Politica_de_Aprecamento.pdf",
            "path": "./docs/PL_06_Politica_de_Aprecamento.pdf",
            "type": "pdf"
        },
        {
            "id": "3",
            "arquivo": "PL_07_Politica_de_Continuidade_de_Negocios.pdf",
            "path": "./docs/PL_07_Politica_de_Continuidade_de_Negocios.pdf",
            "type": "pdf"
        },
        {
            "id": "4",
            "arquivo": "PL.08_Política de ANS.pdf",
            "path": "./docs/PL_08_Politica_de_ANS.pdf",
            "type": "pdf"
        },
        {
            "id": "5",
            "arquivo": "PL.09 Política de Sustentabilidade.pdf",
            "path": "./docs/PL_09_Politica_de_Sustentabilidade.pdf",
            "type": "pdf"
        }
    ]

    const gridImage = (sectionIndex) => <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center">
        <Grid item sm={12} md={12} xl={8}>
            <div key={sectionIndex}>
                <ImageCarousel key={sectionIndex} images={sections[sectionIndex].images}/>
            </div>
        </Grid>
    </Grid>

    return <SideBarLayout
        title={TITLE_METODOLOGIA_PAGE}
        header
        loading={false}
        headerImage="/background/treinamento_header.jpg"
        headerPosition={"1% 41%"}
        headerTitle={TITLE_METODOLOGIA_PAGE}
    >
        <Paper
            sx={{
                mt: -2,
            }}
        >
            <TabsWrappedLabel
                tabs={[
                    {
                        value: "aba1",
                        label: "CURVAS",
                        content: <><br/>{gridImage(0)}</>,
                    },
                    {
                        value: "aba2",
                        label: "RECEBÍVEIS",
                        content: <><br/>{gridImage(1)}</>,
                    },
                    {
                        value: "aba3",
                        label: "PREÇOS",
                        content: <><br/>{gridImage(2)}</>,
                    },
                    {
                        value: "aba4",
                        label: "DOCUMENTAÇÃO",
                        content: <TabelaDownloadArquivo rows={docs}/>,
                    },
                ]}
            />
        </Paper>

        <br/>

    </SideBarLayout>
}

export default MetodologiaPage